import React, {Component} from 'react';
import {Tooltip, Overlay} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';

class InstructionInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false,
    };
    this.target = React.createRef();
  }

  render(props) {
    let myTooltip = (
      <Tooltip
        className={`infoTooltip ${this?.props?.tooltipClassName || ''}`}
        onMouseEnter={() => this.setState({showTaskTooltip: true})}
        onMouseLeave={() => this.setState({showTaskTooltip: false})}
      >
        {this.props && this.props.desc ? this.props.desc : 'Tooltip info'}
      </Tooltip>
    );

    return (
      <>
        <span
          className="instruction-info-span"
          ref={this.target}
          onMouseEnter={() => this.setState({showTooltip: true})}
          onMouseLeave={() => this.setState({showTooltip: false})}
        >
          <FontAwesomeIcon
            className={`fa-icon instrictionIcon ${
              this?.props?.className || ''
            }`}
            style={this.props.style}
            icon={faInfoCircle}
          />
        </span>

        <Overlay
          show={this.state.showTooltip}
          onHide={() => this.setState({showTooltip: false})}
          placement="bottom"
          target={() => this.target.current}
          className="popover"
        >
          {myTooltip}
        </Overlay>
      </>
    );
  }
}

export default InstructionInfo;
